var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Card',{style:({ width: _vm.isMobile ? '300px' : '434px' })},[_c('CardHeader',{key:"brokerage",attrs:{"slot":"title","title":"ROI: Real Estate vs Securities"},slot:"title"}),_vm._v(" "),_c('Row',{staticClass:"feature-card",attrs:{"type":"flex","justify":"center","align":"middle"}},[_c('REvMarket',{staticStyle:{"height":"100%","width":"100%"}})],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4f2b3d28","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/REvMarketCard.vue
// module id = nsN4
// module chunks = 1